// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.adGroupModal .theme--light.v-data-table .v-data-table-header th {\n    color: #fff !important;\n    background-color: #385F73 !important;\n}\n", ""]);
// Exports
module.exports = exports;
